
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Reintegro } from '@/models';

@Component
export default class CardReintegro extends Vue {
    @Prop() private reintegro!: Reintegro;
    @Prop({ default: false }) private compact!: boolean;

    private showDetail() {
        this.$router.push({ name: 'reintegro', params: { id: this.reintegro.id }});
    }
}
